import React, { lazy } from 'react';
import SkeletonGrid from '../../../../skeleton_loaders/common/SkeletonGrid.jsx';
import withSuspense from '../../../../helpers/withSuspense.jsx';

const GridChartWidget = withSuspense(lazy(() => import('./GridChartWidget.jsx')), <SkeletonGrid />)

export default GridChartWidget;
